import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ViewIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24.53 15"
      height={getDefaultHeight(svgProps, 15)}
      {...svgProps}
    >
      <g
        fill="none"
        stroke={color ?? "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path d="M12.263.751C8.176.683 3.949 3.5 1.292 6.385a1.646 1.646 0 000 2.226c2.6 2.824 6.814 5.706 10.971 5.637 4.157.069 8.373-2.813 10.974-5.637a1.646 1.646 0 000-2.226C20.577 3.5 16.35.683 12.263.751z" />
        <path d="M16.066 7.5a3.8 3.8 0 11-3.8-3.751 3.776 3.776 0 013.8 3.751z" />
      </g>
    </SVG>
  );
};
